import React, { useRef, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './css/index.module.css';
import AddProject from './AddProject';
import AddMilestones from './AddMilestones';
import AddOrganisationDetail from './AddOrganisationDetail';
import AddPublicProfiles from './AddPublicProfiles';
import AddCompetitors from './AddCompetitors';
import AddLinkedinProfiles from './AddLinkedinProfiles';
import AddTechnologyDetails from './AddTechnologyDetails';
import EmailPreferences from './EmailPreferences';
import FeatureVisibility from './FeatureVisibility';
import { Link, Element, scrollSpy } from 'react-scroll';
import { useLocation, useNavigate } from 'react-router';

const Main = () => {
    const { selectedProject } = useSelector(state => state.projectData);
    const { user } = useSelector(state => state.user);

    // Check if user is project admin
    const isProjectAdmin = React.useMemo(() => {
        if (!selectedProject || !user) return false;
        return selectedProject?.vdr?.vdr_admin === user?.id || selectedProject?.project_admins?.some(admin => admin.user_id === user?.id);
    }, [selectedProject, user]);

    // Build links array - include Lens Features only for admins (Scheduling Mode toggle deferred)
    const baseLinks = ['Project details', 'Milestones', 'Organisation details', 'Public profiles', 'Competitors', 'CXO Profiles', 'Technology details', 'Email Preferences'];
    const links = isProjectAdmin ? [...baseLinks, 'Lens Features'] : baseLinks;

    const [selectedLink, setSelectedLink] = React.useState('Project details');
    const navigate = useNavigate();
    const location = useLocation();
    console.log({ location });
    function compareObjectsValues(obj1, obj2) {
        console.log({ obj1, obj2 });
        for (let key in obj2) {
            // Special handling for project_milestones field (array of objects)
            if (key === 'project_milestones') {
                const milestones1 = Array.isArray(obj1?.[key]) ? obj1[key] : [];
                const milestones2 = Array.isArray(obj2[key]) ? obj2[key] : [];
                const normalize = arr =>
                    (arr || []).filter(
                        item =>
                            (item.milestoneName && item.milestoneName.trim() !== '') ||
                            (item.milestoneDate && item.milestoneDate.trim() !== '') ||
                            item.created_at,
                    );
                const norm1 = normalize(milestones1);
                const norm2 = normalize(milestones2);
                if (JSON.stringify(norm1) !== JSON.stringify(norm2)) {
                    return false;
                }
                continue;
            }

            if (obj1?.hasOwnProperty(key)) {
                // Special handling for enabled_features field (nested object)
                if (key === 'enabled_features') {
                    const features1 = obj1[key];
                    const features2 = obj2[key];

                    // Compare as JSON strings for deep object comparison
                    const features1Str = JSON.stringify(features1 || {});
                    const features2Str = JSON.stringify(features2 || {});
                    if (features1Str !== features2Str) {
                        return false;
                    }
                    continue; // Skip the default comparison for this field
                }

                if (key === 'scope_areas') {
                    const areas1 = Array.isArray(obj1[key]) ? [...obj1[key]].sort() : [];
                    const areas2 = Array.isArray(obj2[key]) ? [...obj2[key]].sort() : [];
                    if (JSON.stringify(areas1) !== JSON.stringify(areas2)) {
                        return false;
                    }
                    continue;
                }

                // Convert null or undefined to empty string for comparison
                const val1 = obj1[key] === null || obj1[key] === undefined ? '' : obj1[key];
                const val2 = obj2[key] === null || obj2[key] === undefined ? '' : obj2[key];

                // Special handling for numeric fields that might be empty strings vs 0
                if (key === 'revenue' || key === 'established_year') {
                    const num1 = val1 === '' ? 0 : Number(val1);
                    const num2 = val2 === '' ? 0 : Number(val2);
                    if (num1 !== num2) {
                        return false;
                    }
                    continue; // Skip the default comparison for these fields
                }

                // Compare the normalized values
                if (val1 !== val2) {
                    return false; // Values are not equal
                }
            } else {
                return false; // Key doesn't exist in the first object
            }
        }
        return true; // All values are equal
    }

    useEffect(() => {
        scrollSpy.update();
    }, []);

    useEffect(() => {
        if (location?.state?.menu) {
            setSelectedLink(location?.state?.menu);
        }
    }, [location?.state?.menu]);

    return (
        <div className={styles.editBody}>
            <div className="row m-0 p-0">
                <div className="col-sm-12 col-md-2 m-0 p-0">
                    <div className={styles.navLinkBody}>
                        {links.map(item => (
                            <div key={item} onClick={() => setSelectedLink(item)} className={(item === selectedLink && styles.selectednavItem) + ' ' + styles.navLinkItem}>
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="col-sm-12 col-md-1 m-0 p-0"></div>
                <div className="col-sm-12 col-md-4 m-0 p-0">
                    <div id="containerElement" className={styles.formBodies}>
                        <div onClick={() => navigate('/overview')} style={{ textAlign: 'right', position: 'relative', top: '18px' }} className={styles.linkBtn}>
                            Back to Project Overview
                        </div>
                        {selectedLink === 'Project details' && <AddProject compareObjectsValues={compareObjectsValues} />}
                        {selectedLink === 'Milestones' && <AddMilestones />}
                        {selectedLink === 'Organisation details' && <AddOrganisationDetail compareObjectsValues={compareObjectsValues} />}
                        {selectedLink === 'Public profiles' && <AddPublicProfiles compareObjectsValues={compareObjectsValues} />}
                        {selectedLink === 'Competitors' && <AddCompetitors />}
                        {selectedLink === 'CXO Profiles' && <AddLinkedinProfiles compareObjectsValues={compareObjectsValues} />}
                        {selectedLink === 'Technology details' && <AddTechnologyDetails compareObjectsValues={compareObjectsValues} />}
                        {selectedLink === 'Email Preferences' && <EmailPreferences compareObjectsValues={compareObjectsValues} />}
                        {selectedLink === 'Lens Features' && <FeatureVisibility compareObjectsValues={compareObjectsValues} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;

// const Main = () => {
//     const links = ['Project details', 'Organisation details', 'Brand details', 'Business details', 'Public profiles', 'Competitors', 'CXO Profiles', 'Technology details'];
//     const [selectedLink, setSelectedLink] = React.useState();
//     function compareObjectsValues(obj1, obj2) {
//         for (let key in obj2) {
//             if (obj1?.hasOwnProperty(key)) {
//                 if (obj1?.[key] !== obj2[key]) {
//                     return false; // Values are not equal
//                 }
//             } else {
//                 return false; // Key doesn't exist in the first object
//             }
//         }
//         return true; // All values are equal
//     }

//     useEffect(() => {
//         scrollSpy.update();
//         // console.log(elementsRefContainer);
//     }, []);

//     console.log(scrollSpy);
//     return (
//         <div className={styles.editBody}>
//             <div className="row m-0 p-0">
//                 <div className="col-sm-12 col-md-2 m-0 p-0">
//                     <div className={styles.navLinkBody}>
//                         {links.map(item => (
//                             <Link
//                                 to={item.replace(' ', '').toLocaleLowerCase()}
//                                 activeClass={styles.selectednavItem}
//                                 spy={true}
//                                 smooth={true}
//                                 key={item}
//                                 offset={-24}
//                                 duration={300}
//                                 // onSetActive={handleSetActive}
//                                 containerId="containerElement">
//                                 <div className={styles.navLinkItem}>{item}</div>
//                                 {/* (item === selectedLink && styles.selectednavItem) + ' ' +  */}
//                             </Link>
//                         ))}
//                     </div>
//                 </div>
//                 <div className="col-sm-12 col-md-1 m-0 p-0"></div>
//                 <div className="col-sm-12 col-md-4 m-0 p-0">
//                     <div id="containerElement" className={styles.formBodies}>
//                         <Element name="projectdetails">
//                             <AddProject compareObjectsValues={compareObjectsValues} />
//                         </Element>

//                         <Element name="organisationdetails">
//                             <AddOrganisationDetail compareObjectsValues={compareObjectsValues} />
//                         </Element>
//                         <Element name="branddetails">
//                             <AddBrandDetails compareObjectsValues={compareObjectsValues} />
//                         </Element>
//                         <Element name="businessdetails">
//                             <AddBusinessDetails compareObjectsValues={compareObjectsValues} />
//                         </Element>
//                         <Element name="publicprofiles">
//                             <AddPublicProfiles compareObjectsValues={compareObjectsValues} />
//                         </Element>
//                         <Element name="competitors">
//                             <AddCompetitors />
//                         </Element>
//                         <Element name="cxoprofiles">
//                             <AddLinkedinProfiles compareObjectsValues={compareObjectsValues} />
//                         </Element>
//                         <Element name="technologydetails">
//                             <AddTechnologyDetails compareObjectsValues={compareObjectsValues} />
//                         </Element>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };
